// extracted by css-extract-rspack-plugin
export default {"root":"RtqxyB","left-aligned":"XndzGQ","leftAligned":"XndzGQ","right-aligned":"EgbHWg","rightAligned":"EgbHWg","heading":"cDih34","postfix":"rWlYnl"};